const baseApiUrl = 'http://3.215.79.71'
const userKey = 'softica_collision_user_key'

export { baseApiUrl, userKey }